import React from "react";
import { webAddresses } from "../utils/contactDetails.js";
import aqaLogo from "../img/aqa-logo-purple.svg";

/**
 * Footer React component.
 * Renders the application footer with company copyright,
 * legal and privacy links, and the AQA logo.
 *
 * @returns {JSX.Element} The footer element for the application.
 */

class Footer extends React.Component {

  /**
  * Renders the footer content including company info, legal links, and logo.
  * @returns {JSX.Element}
  */
  render() {
    return (
      <footer id="footer">
        <div className="company-links">
          <div>
            <p>&copy; Doublestruck Ltd. {new Date().getFullYear()}, All rights reserved</p>
          </div>
          <div>
            <ul>
              <li>
                <a
                  href={webAddresses.termsAndConditions.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href={webAddresses.privacyStatement.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Notice
                </a>
              </li>
              <li>
                <a
                  href={webAddresses.cookiePolicy.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie Policy
                </a>
              </li>
              <li>
                <a
                  href={webAddresses.gdpr.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GDPR
                </a>
              </li>
            </ul>
          </div>
          <div className="img-container">
            <img alt="aqa-logo" className="aqa-logo" src={aqaLogo} />
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
